import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  group: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.10)",
    background: "#fff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  btn: {
    borderRadius: 0,
    padding: 10,
    height: 40,
    width: 44,
    transition: "background .12s ease",
    "&:hover": {
      background: "rgba(0,0,0,0.04)",
    },
  },
  divider: {
    width: 1,
    height: 24,
    background: "rgba(0,0,0,0.10)",
  },
  backBtn: {
    width: "auto",
    paddingLeft: 10,
    paddingRight: 14,
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  icon: {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
  text: {
    fontWeight: 800,
    fontSize: 13,
    color: theme.palette.text.primary,
    userSelect: "none",
  },
}));

export default function NavActionsMentora({onHome, onBack, backText = "Regresar", showBackText = false, showHome = false, homeTooltip = "Inicio", backTooltip = "Regresar"}) {
  const classes = useStyles();
  return (
    <div className={classes.group}>
      {showHome && (
        <>
          <Tooltip title={homeTooltip}>
            <IconButton className={classes.btn} onClick={onHome}>
              <HomeIcon className={classes.icon} />
            </IconButton>
          </Tooltip>

          <div className={classes.divider} />
        </>
      )}
      <Tooltip title={backTooltip}>
        <IconButton
          className={`${classes.btn} ${classes.backBtn}`}
          onClick={onBack}
        >
          <ArrowBackIcon className={classes.icon} />
          {showBackText && (
            <Typography className={classes.text}>{backText}</Typography>
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
}
